{
  "General_InitContext_Undefined": "Die Bestellung ist nicht verfügbar. Suchen Sie ein Produkt auf der Website und klicken Sie dort auf bestellen",
  "General_Api_Failed": "Es hat einen Fehler beim Abrufen der Daten gegeben. Bitte laden Sie die Seite neu und versuchen Sie es noch einmal.",
  "General_MoreDetails": "Weitere Details",
  "General_LessDetails": "Weniger Details",
  "General_Page_Back": "Zurück",
  "General_Page_Next": "Weiter",
  "General_WishdateType_Asap": "Schnellstmöglich",
  "General_Config_Error":"Fehler in Produktkonfiguration. Bitte Produktmanager informieren.",

  "Cart_Title": "Ihre Bestellung",
  "Cart_Header_NonRecurring": "Einmalig",
  "Cart_Header_NonRecurring_Short": "Einm.",
  "Cart_Header_Monthly": "Monatlich",
  "Cart_Header_Monthly_Short": "Mtl.",
  "Cart_Subtotal": "Zwischentotal",
  "Cart_Total": "Total CHF",
  "Cart_Prices_Incl_Vat": "Alle Preise in CHF, inkl. MWST",
  "Cart_Prices_Excl_Vat": "Alle Preise in CHF, exkl. MWST",
  "Cart_Partner_Number": "Partner-ID: {partnerNumber}",
  "Cart_Mindestvertragsdauer_12Mt": "Die Mindestvertragsdauer beträgt 12 Monate ab dem ersten Tag der Abo-Verrechnung.",

  "ConfigsNavigation_Access" : "Internet-Installation",
  "ConfigsNavigation_Phone" : "Telefonie-Installation",
  "ConfigsNavigation_Tv" : "TV-Installation",
  "ConfigsNavigation_Mobile" : "Mobile-Installation",
  "ConfigsNavigation_NoConfigs": "Keine Einstellungen",

  "Configs_No_Configs": "Nichts einzustellen",
  "ConfigsAccess_Title": "Ihren Internetanschluss aktivieren",
  "ConfigsAccess_Wishdate_Title": "Ab wann möchten Sie Ihr neues Internet-Abo nutzen?",
  "ConfigsAccess_WishdateType_Asap": "So schnell wie möglich (5-10 Arbeitstage)",
  "ConfigsAccess_WishdateType_Wishdate": "Wunschdatum",
  "ConfigsAccess_WishdateType_Landline": "Gleiches Datum wie der Festnetz-Anschluss",

  "ConfigsTv_Wishdate_Title": "Ab wann möchten Sie Ihr TV-Abo nutzen?",
  "ConfigsTv_Wishdate_Asap": "So schnell wie möglich",
  "ConfigsTv_Wishdate_Wishdate": "Wunschdatum",
  "ConfigsTv_WishdateType_Landline": "Gleiches Datum wie der Festnetz-Anschluss",

  "ConfigsAccess_FixIp_Title": "RIPE-Registrierung für fixe IP-Adressen",
  "ConfigsAccess_FixIp_Subtitle": "Ab einem IP-Subnetz von 4 oder mehr IP-Adressen ist eine Registrierung bei der Vergabestelle RIPE erforderlich. Bitte machen Sie dazu folgende Angaben:",
  "ConfigsAccess_FixIp_HandleLabel": "RIPE-Handle (wenn bereits vorhanden)",
  "ConfigsAccess_FixIp_ReasonLabel": "Firma, Zweck",
  "ConfigsAccess_FixIp_ReasonInfo": "Beschreiben Sie die Tätigkeit Ihrer Firma und für welchen Zweck Sie die IP-Adressen benötigen.",
  "ConfigsAccess_FixIp_OneRequired": "Geben Sie entweder einen RIPE-Handle oder eine Begründung (Firma, Zweck) an.",

  "ConfigsAccess_OtoId_Title": "Wie lautet die Nummer Ihrer Glasfasersteckdose (OTO-ID)?",
  "ConfigsAccess_OtoId_Info": "Die Glasfasersteckdose befindet sich in der Regel im Multimedia-Verteilkasten oder neben der bestehenden Telefon-/TV-Dose in Ihrem Wohnzimmer. Jede Glasfasersteckdose hat eine Nummer, die sogenannte OTO-ID. Diese beginnt in der Regel mit A.XXX oder B.XXX. Bitte geben Sie  diese bei der Bestellung an.",
  "ConfigsAccess_OtoId_NotAvailable": "Noch keine Glasfasersteckdose vorhanden",
  "ConfigsAccess_OtoId_NotAvailable_Info": "Die Aktivierungszeit ist unbestimmt. In der Regel kann die Glasfaserdose innerhalb von 4 bis 6 Wochen installiert werden.",
  "ConfigsAccess_OtoId_CheckerList": "Aus Liste wählen",
  "ConfigsAccess_OtoId_OwnEntry": "OTO-ID eingeben",
  "ConfigsAccess_OtoId_OwnEntry_Placeholder": "Wenn Sie eine Glasfasersteckdose haben, geben Sie bitte die ID auf der Dose ein.",
  "ConfigsAccess_OtoId_PleaseSelect": "OTO-ID auswählen",

  "ConfigsAccess_PreviousTenant_Title": "Übernehmen Sie den Anschluss eines Vormieters?",
  "ConfigsAccess_PreviousTenant_Info": "Bitte geben Sie an, ob es sich um einen neuen Anschluss handelt oder ob Sie den Anschluss eines Vormieters bzw. eines anderen Anbieters übernehmen.",
  "ConfigsAccess_PreviousTenant_DslNew": "Bestehende Leitungsnummer / Name Vormieter unbekannt",
  "ConfigsAccess_PreviousTenant_DslNew_Info": " Auftrag an Elektrikerin / Elektriker auf eigene Kosten erforderlich",
  "ConfigsAccess_PreviousTenant_DslProviderChange": "Anbieterwechsel / Übernahme eines bestehenden Anschlusses",
  "ConfigsAccess_PreviousTenant_DslNumber_Label": "Leitungsnummer oder Name des Vormieters",
  "ConfigsAccess_PreviousTenant_DslNumber_Info": "Bitte geben Sie entweder die Leitungsnummer (NSN-Nummer) oder den Namen/Vornamen und/oder die Telefonnummer der Vormieterin/des Vormieters an",

  "ConfigsPhone_Wishdate_Title": "Wann sollen wir Ihr Abo aufschalten?",
  "ConfigsPhone_WishdateType_Asap": "So schnell wie möglich",
  "ConfigsPhone_WishdateType_Wishdate": "Wunschdatum",

  "ConfigsPhone_Porting_Date_Info_Title": "Die Übernahme Ihrer Nummern klären wir in einem nächsten Schritt",
  "ConfigsPhone_Porting_Date_Info": "Nachdem wir Ihre Bestellung erhalten haben, schicken wir Ihnen ein Formular per E-Mail. Dort geben Sie an, wann Ihr bisheriger Vertrag endet und ob wir das Vertragsende abwarten sollen. Wir teilen Ihnen das effektive Umschaltdatum anschliessend mit.",
  "ConfigsPhone_AdditionalNumbers_Title": "Einzelne Rufnummern",
  "ConfigsPhone_AdditionalNumbers_Question": "Wie viele Festnetz-Nummern möchten Sie?",
  "ConfigsPhone_AdditionalNumbers_Info": "Geben Sie an, wie viele Nummern Sie möchten.",
  "ConfigsPhone_AdditionalNumbers_Monthly": "monatlich",
  "ConfigsPhone_AdditionalNumbers_Included": "inbegriffen",
  "ConfigsPhone_AdditionalNumbers_NonRecurring": "einmalig",

  "ConfigsPhone_NewOrPorting_Title": "Neue und bestehende Rufnummern",
  "ConfigsPhone_NewOrPorting_New_Label": "Neu",
  "ConfigsPhone_NewOrPorting_Ported_Label": "Bestehend",
  "ConfigsPhone_NewOrPorting_New_Question": "Neue Rufnummern",
  "ConfigsPhone_NewOrPorting_Ported_Question": "Bestehende Rufnummern",
  "ConfigsPhone_NewOrPorting_Monthly": "monatlich",
  "ConfigsPhone_NewOrPorting_NonRecurring": "einmalig",

  "ConfigsPhone_LandlineNew_Title": "Neue Rufnummer",
  "ConfigsPhone_LandlineNew_Label": "Wunschvorwahl",

  "ConfigsPhone_LandlinePorting_Title": "Bestehende Rufnummer portieren/übernehmen",
  "ConfigsPhone_LandlinePorting_WishdateType_Wishdate": "Wunschdatum",
  "ConfigsPhone_LandlinePorting_WishdateType_Wishdate_Info": "Ich möchte meine Nummer vor Ablauf der Mindestvertragsdauer übertragen und bin einverstanden, dem bisherigen Anbieter alle deswegen geschuldeten Zahlungen zu leisten.",
  "ConfigsPhone_LandlinePorting_WishdateType_ContractExpiry": "Datum des Vertragsablaufs",
  "ConfigsPhone_LandlinePorting_WishdateType_ContractExpiry_Info": "Ich möchte die Vertragsdauer bei meinem bisherigen Anbieter einhalten. (Das genaue Umschaltdatum erhalten Sie von uns per E-Mail).",
  "ConfigsPhone_LandlinePorting_Wishdate_Placeholder": "Datum wählen",
  "ConfigsPhone_LandlinePorting_Enter_Number":"Wie lautet die bestehende Festnetz-Nummer?",
  "ConfigsPhone_LandlinePorting_NumberEntry_Label": "Rufnummer",
  "ConfigsPhone_LandlinePorting_Number_Example":"Beispiel: 044 123 45 67",

  "ConfigsMobile_Number_Title": "Möchten Sie eine neue Mobilnummer?",
  "ConfigsMobile_Number_New": "**Ja**, ich möchte eine neue Mobilnummer",
  "ConfigsMobile_Number_Porting": "**Nein**, ich möchte meine Mobilnummer vom bestehenden Anbieter übernehmen",
  "ConfigsMobile_Number_Product_Not_Configured": "Konfigurationsfehler - gewünschtes Produkt ist nicht konfiguriert",

  "ConfigsMobile_Sim_Title": "SIM-Karte",
  "ConfigsMobile_Sim_Monthly": "monatlich",
  "ConfigsMobile_Sim_NonRecurring": "einmalig",

  "ConfigsMobile_MultiSim_Title": "Multi-SIM",
  "ConfigsMobile_MultiSim_None": "Keine Multi-SIM",
  "ConfigsMobile_MultiSim_Multi": "Multi-SIM (Standard- und eSim)",
  "ConfigsMobile_MultiSim_Monthly": "monatlich",
  "ConfigsMobile_MultiSim_NonRecurring": "einmalig",

  "ConfigsMobile_New_Title": "Ab wann möchten Sie Ihre neue Mobilnummer nutzen?",
  "ConfigsMobile_New_WishdateType_Asap": "So schnell wie möglich",
  "ConfigsMobile_New_WishdateType_Wishdate": "Wunschdatum",

  "ConfigsMobile_Porting_Title": "Ihr bisheriges Abo",
  "ConfigsMobile_Porting_Title_Info": "Für die Übernahme Ihrer Mobilnummer benötigen wir folgende Angaben:",
  "ConfigsMobile_Porting_MobileNumber_Label": "Mobilnummer",
  "ConfigsMobile_Porting_Type_NotComply": "Wunschdatum",
  "ConfigsMobile_Porting_Type_NotComply_Info": "Ich möchte meine Nummer vor Ablauf der Mindestvertragsdauer übertragen und bin einverstanden, dem bisherigen Anbieter alle deswegen geschuldeten Zahlungen zu leisten.",
  "ConfigsMobile_Porting_Type_Comply": "Datum des Vertragsablaufs",
  "ConfigsMobile_Porting_Type_Comply_Info": "Ich möchte die Vertragsdauer bei meinem bisherigen Anbieter einhalten (Sie dürfen die Anfrage höchstens 365 Tage vor Vertragsablauf stellen).",
  "ConfigsMobile_Porting_Date_Placeholder": "Datum wählen",
  "ConfigsMobile_Porting_Time_Label": "Uhrzeit der Portierung/Rufnummernübernahme",
  "ConfigsMobile_Porting_PreviousProvider_Label": "Bisheriger Anbieter",
  "ConfigsMobile_Porting_PreviousProvider_PleaseSelect": "Bitte wählen",
  "ConfigsMobile_Porting_PreviousSubscriptionType_Label": "Bisheriges Abo-Modell",
  "ConfigsMobile_Porting_PreviousSubscriptionType_PleaseSelect": "Bitte wählen",
  "ConfigsMobile_Porting_PreviousSubscriptionType_Prepaid": "Prepaid",
  "ConfigsMobile_Porting_PreviousSubscriptionType_Postpaid": "Monatsabo",
  "ConfigsMobile_Porting_Prepaid_Sms_Title": "Ein Schritt von Ihnen: Abmelde-SMS",
  "ConfigsMobile_Porting_Prepaid_Sms_Info": "Senden Sie jetzt ein SMS mit dem Wort **JA** an die Nummer **499** noch von Ihrer bisherigen SIM-Karte aus. Ohne diese Bestätigung kann Ihr bisheriger Anbieter die Übernahme ablehnen. Eine Vollmacht brauchen wir bei Prepaid nicht.",

  "ConfigsMobile_Porting_Wishdate_Title": "Wann soll die Nummer zu uns wechseln?",
  "ConfigsMobile_Porting_Wishdate_Prepaid_Info": "Bei Prepaid gibt es keine Kündigungsfrist – die Nummer wechselt so schnell wie möglich, jedoch frühestens in 4 Arbeitstagen.",
  "ConfigsMobile_Porting_Wishdate_End_Of_Contract_Title":"Sie wissen nicht, wann Ihr Vertrag abläuft?",
  "ConfigsMobile_Porting_Wishdate_End_Of_Contract_Info":"Senden Sie ein SMS mit dem Text «Info» an die Nummer 503. So erfahren Sie Ihre Mindestvertragsdauer und allfällige Kündigungskosten.",
  "ConfigsMobile_Porting_Wishdate_PreviousSubscriptionEndDate_Label": "Datum des Vertragsendes",
  "ConfigsMobile_Porting_Wishdate_Wishdate_Label": "Wunschdatum",
  "ConfigsMobile_Porting_ChangeOwner_Title": "Wem gehört das bisherige Abo?",
  "ConfigsMobile_Porting_ChangeOwner_No": "Ich bin Inhaberin oder Inhaber des bisherigen Abos.",
  "ConfigsMobile_Porting_ChangeOwner_Yes": "Das bisherige Abo lautet auf eine andere Person.",
  "ConfigsMobile_Porting_ChangeOwner_FirstName_Label": "Vorname",
  "ConfigsMobile_Porting_ChangeOwner_LastName_Label": "Nachname",
  "ConfigsMobile_Porting_ChangeOwner_Birthdate_Label": "Geburtsdatum",
  "Completion_Base_Change_Order": "Bestellung ändern",
  "Completion_Base_Change": "ändern",
  "Completion_Base_Address_Invoice_Title": "Rechnungsadresse",
  "Completion_Base_Address_Delivery_Title": "Lieferadresse",
  "Completion_Base_Address_Technical_Title": "Adresse des technischen Kontakts",
  "Completion_Base_Address_Same_As_Invoice_Address": "Gleich wie Rechnungsadresse",
  "Completion_Base_Use_Invoice_Address": "Gleich wie Rechnungsadresse",
  "Completion_Base_Installation":"Installation",
  "Competion_Tv_Config_Title": "TV",

  "Confirmation_Thank_You": "Vielen Dank für Ihre Bestellung!",
  "Confirmation_Next_Steps": "Die nächsten Schritte",
  "Confirmation_Step_Email_Confirmation": "Sie erhalten eine Bestätigung per E-Mail",
  "Confirmation_Step_Hardware_Shipment":"Sie erhalten die Geräte per Post",
  "Confirmation_Step_Product_Activation":"Wir schalten die Produkte auf",
  "Confirmation_Step_Product_Usage": "Sie können loslegen",

  "CustomerData_Address_Invoice_Title": "Kontaktdaten",
  "CustomerData_Address_Invoice_AddressPartTitle": "Rechnungsadresse",
  "CustomerData_Address_Invoice_PhonePartTitle": "Wie erreichen wir Sie?",
  "CustomerData_Address_Delivery_Title": "Wohin soll die Lieferung gehen?",
  "CustomerData_Address_Delivery_AddressPartTitle": "Lieferadresse",
  "CustomerData_Address_Delivery_PhonePartTitle": "Wie erreichen wir jemanden an der Lieferadresse?",
  "CustomerData_Address_Technical_Title": "Technischer Kontakt",
  "CustomerData_Address_Technical_AddressPartTitle": "Adresse",
  "CustomerData_Address_Technical_PhonePartTitle": "Wie erreichen wir den technischen Kontakt?",
  "CustomerData_Address_SameAsInvoice": "Gleich wie Rechnungsadresse",
  "CustomerData_ShowDeliveryAddress": "Abweichende Lieferadresse",
  "CustomerData_ShowTechnicalAddress": "Abweichende Adresse für technischen Kontakt",
  "CustomerData_Address_One_Phone_Required":"Geben Sie mindestens eine Nummer an",
  "CustomerData_BillingType_Title": "Rechnungszustellung",
  "CustomerData_BillingType_Email_Label": "Rechnung per E-Mail oder als eBill",
  "CustomerData_BillingType_Email_Info": "(eBill erfordert Anmeldung über E-Banking)",
  "CustomerData_BillingType_Post_Label": "Papierrechnung auf dem Postweg",
  "CustomerData_BillingType_Post_Info": "(CHF {amount}/Rechnung)",
  "CustomerData_BillingPeriod_Title": "Zahlungsperiode",
  "CustomerData_BillingPeriod_MIV_Label": "Monatlich",
  "CustomerData_BillingPeriod_JIV_Label": "Jährlich",
  "CustomerData_BillingPeriod_HIV_Label": "Halbjährlich",
  "CustomerData_BillingPeriod_QIV": "Vierteljährlich",
  "CustomerData_Address_ContactType_Private": "Privatperson",
  "CustomerData_Address_ContactType_Company": "Firma",
  "CustomerData_Address_CompanyName_Label": "Firmenname",
  "CustomerData_Address_Uid_Label": "UID",
  "CustomerData_Address_Gender_Label": "Anrede",
  "CustomerData_Address_Gender_Male": "Herr",
  "CustomerData_Address_Gender_Female": "Frau",
  "CustomerData_Address_Gender_Other": "Keine Angabe",
  "CustomerData_Address_FirstName_Label": "Vorname",
  "CustomerData_Address_LastName_Label": "Nachname",
  "CustomerData_Address_Birthdate_Label": "Geburtsdatum",
  "CustomerData_Address_Street_Label": "Strasse",
  "CustomerData_Address_BuildingNumber_Label": "Hausnummer",
  "CustomerData_Address_Zip_Label": "PLZ",
  "CustomerData_Address_City_Label": "Ort",
  "CustomerData_Address_ZipCity_Label": "PLZ / Ort",
  "CustomerData_Address_CountryCode_Label": "Land",
  "CustomerData_Address_Email_Label": "E-Mail-Adresse",
  "CustomerData_Address_Phone_Label": "Telefonnummer",
  "CustomerData_Address_Mobile_Label": "Mobilnummer",
  "CustomerData_Address_Save": "Änderungen übernehmen",
  "CustomerData_Address_Saved": "Gespeichert",
 
  "Fallback_Title":"Keine Bestellung gefunden",
  "LanguageSwitch_CurrentLanguage": "Deutsch",

  "MainProducts_AccessInstallationAddress":"Installationsadresse",
  "MainProducts_AccessInstallationAddress_Change":"Adresse ändern",
  "MainProducts_Title": "Stellen Sie Ihr persönliches Paket zusammen",
  "MainProducts_Title_Konfigurator":"Wählen Sie das passende Produkt",
  "MainProducts_Required_Combinations": "Welche Produkte möchten Sie kombinieren?",
  "MainProducts_Required_Combinations_Konfigurator": "Wählen Sie ein oder mehrere Produkte",
  "MainProducts_ShowMoreBandwidth":"Für weitere Geschwindigkeiten geben Sie bitte Ihre Adresse an.",
  "MainProducts_ShowChecker":"Weitere Angebote finden",
  "MainProducts_Save_Order_Not_Available":"Die Bestellung ist nicht verfügbar. Suchen Sie auf der Website nach einem Produkt oder verwenden Sie den Adressprüfer.",
  "MainProducts_AccessMaxDownload": "Max. Download:",
  "MainProducts_AccessMaxUpload": "Max. Upload:",
  "MainProducts_Access_Use_Speed_With_Profiles": "Diese Geschwindigkeiten können Sie mit den unten aufgeführten Internet-Abos nutzen.",
  "MainProducts_Access_First_Use_Checker": "Bitte geben Sie zuerst Ihre Adresse an, damit wir Ihnen die verfügbaren Internet-Abos anzeigen können.",

  "Navigation_Products_Title": "Produkte",
  "Navigation_Options_Title": "Optionen",
  "Navigation_Installation_Title": "Installation",
  "Navigation_Information_Title": "Angaben",
  "Navigation_Completion_Title": "Abschluss",
  "Completion_ConfigValues_Title": "Produktkonfiguration",
  "Completion_Terms_Title": "Abo-Bestimmungen",
  "Completion_Terms_Required": "Bitte akzeptieren Sie die Abo-Bestimmungen, um die Bestellung abzuschliessen.",
  "Completion_Submit": "Verbindlich bestellen",
  "Completion_Get_Link": "Link erstellen",
  "Completion_Print_Quote_Pdf": "Offerte als PDF",
  "Completion_Link_Copy": "Kopieren",
  "Completion_Link_Copied": "Kopiert",
  "Completion_Issues_Title": "Die Bestellung kann aus folgenden Gründen nicht abgeschlossen werden:",

  "Completion_VoucherCode_Title": "Gutscheincode",
  "Completion_VoucherCode_Label": "Gutscheincode",
  "Completion_VoucherCode_Save": "Einlösen",

  "Completion_ReferrerCode_Title": "Empfehlungscode",
  "Completion_ReferrerCode_Label": "Empfehlungscode",
  "Completion_ReferrerCode_Save": "Einlösen",

  "Completion_Tv_Config_Title": "TV",
  "Completion_Tv_Config_Wishdate": "Wunschdatum",

  "Completion_Access_Config_Title": "Internetanschluss",
  "Completion_Access_Config_Wishdate": "Aufschaltung",
  "Completion_Access_Config_Asap": "Schnellstmöglich",
  "Completion_Access_Config_FirstActivationDate": "Zum Erschliessungstermin",
  "Completion_Access_Config_Per": "Per",
  "Completion_Access_Config_DslNumber": "Vorgänger-Nummer",
  "Completion_Access_Config_DslTenant": "Vormieter",
  "Completion_Access_Config_OtoId": "OTO-ID",
  "Completion_Access_Config_OtoId_NotAvailable": "Noch keine OTO-ID vorhanden",

  "Completion_Access_FixIp_Title": "RIPE-Registrierung",
  "Completion_Access_FixIp_RipeHandle": "RIPE-Handle",
  "Completion_Access_FixIp_RipeReason": "Zweck",

  "Completion_Landline_Config_Wishdate":"Neue Nummern aufschalten",
  "Completion_Landline_Config_Per":"Per",
  "Completion_Landline_Config_Asap": "Schnellstmöglich",

  "Completion_Landline_Config_Title":"Festnetznummern",
  "Completion_LandlineNew_Config_Title":"Neue Festnetznummern",
  "Completion_LandlineNew_Config_NumberPrefix":"Vorwahl",
  "Completion_LandlineNew_Config_NumberPrefixNull": "Beliebig",
  "Completion_LandlinePorting_Config_Title":"Nummmern übernehmen",
  "Completion_LandlinePorting_PortingDate":"Das genaue Portierungsdatum wird nach der Bestellung abgeklärt",

  "Completion_Mobile_Config_Title": "Mobile",
  "Completion_Mobile_Config_NewNumber": "Neue Mobilnummer",
  "Completion_Mobile_Config_Wishdate": "Aufschaltung",
  "Completion_Mobile_Config_Asap": "Schnellstmöglich",
  "Completion_Mobile_Config_Per": "Per",
  "Completion_Mobile_Config_Porting_MobileNumber": "Mobilnummer",
  "Completion_Mobile_Config_Porting_Type": "Portierung",
  "Completion_Mobile_Config_Porting_Type_NotComply": "Vor Ablauf der Mindestvertragsdauer",
  "Completion_Mobile_Config_Porting_Type_Comply": "Per Vertragsablauf",
  "Completion_Mobile_Config_Porting_Date": "Wunschdatum",
  "Completion_Mobile_Config_Porting_PreviousProvider": "Bisheriger Anbieter",
  "Completion_Mobile_Config_Porting_PreviousSubscriptionType": "Bisheriges Abo-Modell",
  "Completion_Mobile_Config_Porting_PreviousSubscriptionType_Prepaid": "Prepaid",
  "Completion_Mobile_Config_Porting_PreviousSubscriptionType_Postpaid": "Monatsabo",
  "Completion_Mobile_Config_Porting_Previous_Owner": "Bisheriger Nummer-Inhaber",

  "Completion_OrderSource_Title": "Wie sind Sie auf uns aufmerksam geworden?",
  "Completion_OrderSource_Label": "Quelle",

  "Completion_Remarks_Title": "Bemerkungen",
  "Completion_Remarks_Label": "Bemerkungen",

  "Price_Nonrecurring": "einmalig",
  "Price_Monthly": "monatlich",
  "Products_Total_CHF": "Total CHF",
  "Products_OrderButton_Label": "Bestellen",
  "Products_Bestseller_Title": "Bestseller",
  "Product_Options_Page_Title": "Optionen",
  "Products_Details_Link_Text": "Details & Abo-Vergleich",


  "OptionsNavigation_NoOptions": "Keine Optionen",
  "OptionsNavigation_Access": "Internet-Optionen",
  "OptionsNavigation_Skip": "Überspringen",
  "OptionsNavigation_Phone": "Telefonie-Optionen",
  "OptionsNavigation_Tv": "TV-Optionen",

  "OptionsBlockRow_Kostenlos": "Kostenlos",
  "OptionsBlockRow_Kostenlos_Leihweise": "Kostenlos leihweise",
  "OptionsBlockRow_IsBestseller": "Bestseller",

  "Options_No_Options": "Keine Optionen",
  "Options_Access_Router_Title": "Geräte für Ihr Internet-Abo",
  "Options_Access_Router_Subtitle": "Welchen Router möchten Sie nutzen?",
  "Options_Access_Router_ShowMore_Title": "Weitere Router",
  "Options_Access_Router_ShowLess_Title": "Weniger Router",
  "Options_Access_Accessories_Title": "Zubehör für Ihr Internet-Abo",
  "Options_Access_Accessories_Subtitle": "Welches Zubehör möchten Sie nutzen?",
  "Options_Access_Accessories_ShowMore_Title": "Weiteres Zubehör",
  "Options_Access_Accessories_ShowLess_Title": "Weniger Zubehör",
  "Options_Access_Installation_Title": "Brauchen Sie Unterstützung bei der Inbetriebnahme des Routers?",
  "Options_Access_Installation_Wanted_No": "**Nein**, ich installiere selbst.",
  "Options_Access_Installation_Wanted_Yes": "**Ja**",

  "Options_Access_Sla_Title": "Erweiterte Supportleistungen",
  "Options_Access_Sla_ShowMore_Title": "Weitere Angebote",
  "Options_Access_Sla_ShowLess_Title": "Weniger Angebote",

  "Options_FixIp_Title": "Erweiterte Optionen: zusätzliche fixe IP-Adressen",
  "Options_FixIp_SubTitle": "Zusätzliche fixe IP-Adressen braucht es nur für spezielle Heimserver, Fernzugriffe oder Anwendungen Ihres IT-Dienstleisters.",
  "Options_FixIp_Not_Selected": "Zusätzliche fixe IP-Adressen",
  "Options_FixIp_NonRecurring": "einmalig",
  "Options_FixIp_Monthly": "monatlich",

  "Options_Mobile_Accessories_Title": "Mobile-Extras",
  "Options_Mobile_Accessories_ShowMore_Title": "Weitere Extras",
  "Options_Mobile_Accessories_ShowLess_Title": "Weniger Extras",

  "Options_Mobile_Optionss_Title": "Optionen zum Mobile-Abo",
  "Options_Mobile_Optionss_ShowMore_Title": "Weitere Optionen",
  "Options_Mobile_Optionss_ShowLess_Title": "Weniger Optionen",

  "Options_Phone_Hardware_Title": "Passende Telefon-Geräte",

  "Options_Phone_Hardware_ShowMore_Title": "Weitere Geräte",
  "Options_Phone_Hardware_ShowLess_Title": "Weniger Geräte",

  "Options_Phone_Accessories_Title": "Telefonie-Extras",
  "Options_Phone_Accessories_ShowMore_Title": "Weitere Extras",
  "Options_Phone_Accessories_ShowLess_Title": "Weniger Extras",

  "Options_Phone_Channel_Title": "Kanäle für Telefonanschluss",
  "Options_Phone_Channel_ShowMore_Title": "Weitere Kanäle",
  "Options_Phone_Channel_ShowLess_Title": "Weniger Kanäle",

  "Options_Phone_Options_Title": "Telefonie-Optionen",
  "Options_Phone_Options_ShowMore_Title": "Weitere Optionen",
  "Options_Phone_Options_ShowLess_Title": "Weniger Optionen",

  "Options_Phone_Sla_Title": "SLA für Telefonie",
  "Options_Phone_Sla_ShowMore_Title": "Weitere SLA",
  "Options_Phone_Sla_ShowLess_Title": "Weniger SLA",

  "Options_Tv_Title":"Optionen für Ihr TV-Abo",

  "Options_TvChannelPack_ChannelsWanted": "Möchten Sie Sprachpakete oder ein Family Paket hinzufügen?",
  "Options_TvChannelPack_ChannelsWanted_No": "**Nein**, mir reicht das TV-Abo.",
  "Options_TvChannelPack_ChannelsWanted_Yes": "**Ja**, ich möchte Pakete hinzufügen.",
  "Options_TvChannelPack_ChannelsWanted_Yes_Info": "Mit unseren TV-Paketen können Sie Ihr Abo durch zusätzliche Sender ergänzen.",
  "Options_TvChannelPack_ShowMore_Title": "Weitere Senderpackete",
  "Options_TvChannelPack_ShowLess_Title": "Weniger Senderpackete",
  "Options_TvChannelPack_Senderlist": "Senderliste",
  
  "Options_TvBox_Title": "TV-Boxen",
  "Options_TvBox_ShowMore_Title": "Weitere TV-Boxen",
  "Options_TvBox_ShowLess_Title": "Weniger TV-Boxen",
  "Options_TvBox_Boxes_Wanted":"Brauchen Sie zusätzliche TV-Boxen?",
  "Options_TvBox_Boxes_Wanted_No":"**Nein**, die im Abo enthaltene TV-Box reicht mir.",
  "Options_TvBox_Boxes_Wanted_Yes":"**Ja**, ich möchte weitere TV-Boxen nutzen.",
  "Options_TvBox_Boxes_Wanted_Yes_Info":"Zusätzliche TV-Boxen erlauben Ihnen, Ihr Abo auf zusätzlichen TV-Geräten zu nutzen.",
  "Options_TvBox_Boxes_Monthly":"monatlich",
  "Options_TvBox_Boxes_NonRecurring":"einmalig",

  "SwissLandlineNumberEntry_Invalid": "Bitte geben Sie eine gültige Schweizer Telefonnummer ein.",
  "SwissLandlineNumberEntry_NoMobile": "Mobilnummern sind nicht zulässig. Bitte geben Sie eine Festnetznummer ein.",
  "SwissMobileNumberEntry_Invalid": "Bitte geben Sie eine gültige Schweizer Mobilnummer ein.",

  "Validation_Failed": "Es gibt ungültige oder fehlende Eingaben. Bitte prüfen Sie die markierten Felder",
  "Validation_Value_Required": "Dieses Feld ist erforderlich.",
  "Validation_Selection_Required":"Eine Auswahl ist erforderlich.",
  "Validation_OtoId_Contains_Invalid_Characters": "Die OTO-ID enthält unzulässige Zeichen",
  "Validation_Swiss_Mobile_Number":"Schweizer Mobilnummer erforderlich",
  "Validation_Referrer_Code_Not_Found": "Dieser Empfehlungscode wurde nicht gefunden.",
  "Validation_Referrer_Code_Not_Valid": "Dieser Empfehlungscode ist ungültig.",
  "Validation_Referrer_Product_Not_Found": "Für diesen Empfehlungscode wurde kein passendes Produkt gefunden.",
  "Validation_Voucher_Code_Not_Valid": "Dieser Gutscheincode ist ungültig.",
  "Validation_Phone_Or_Mobile_Required": "Telefon- oder Mobilnummer sind erforderlich.",
  "Validation_Must_Be_18": "Sie müssen 18 Jahre alt sein, um bestellen zu können",
  "Validation_Ripe_Format": "Das ist keine korrekte Ripe-Adresse",
  "Validation_Incomplete": "Fehlende Daten",
  "Validation_Out_Of_Range": "Auswahl unzulässig",

  "Issue_Key_invoice_address":"Rechnungsadresse",
  "Issue_Key_delivery_address":"Lieferadresse",
  "Issue_Key_technical_address":"Technischer Kontakt",
  "Issue_Key_access_dsl_config":"Konfiguration DSL-Internet",
  "Issue_Key_access_fiber_config":"Konfiguration Fiber-Internet",
  "Issue_Key_landline_config":"Konfiguration Festnetzanschluss",
  "Issue_Key_landline_new_config":"Konfiguration neue Festnetznummer",
  "Issue_Key_landline_porting_config":"Konfiguration übernommene Festnetznummer",
  "Issue_Key_mobile_new_config":"Konfiguration neue Mobilnummer",
  "Issue_Key_mobile_porting_config":"Konfiguration übernommene Mobilnummer",
  "Issue_Key_tv_config":"Konfiguration TV",

  "Variant_Not_Found":"Variante nicht gefunden oder nicht verfügbar",
  "Product_Not_Found":"Produkt nicht gefunden oder nicht verfügbar",

  "ZZZ_EndOfFile": ""
}